import "./App.css";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import "./styles/style.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import Register from "./pages/Register";
import LoginPage from "./pages/LoginPage";
import NotFound from "./pages/NotFound";
import { Authentication } from "./useAuth";
import { ProfilePage } from "./pages/ProfilePage";
import AppAuth from "./AppAuth";
import Homepage from "./pages/Homepage";
import AddDailyUpdate from "./pages/AddDailyUpdate";
import RequireAuth from "./Components/global/RequireAuth";
import DailyUpdatesList from "./pages/DailyUpdatesList";
import AddNewQuestion from "./pages/AddNewQuestion";
import QuestionsList from "./pages/QuestionsList";
import AddQuestionsInBulk from "./pages/AddQuestionsInBulk";
import AddSubject from "./pages/AddSubject";
import SubjectsList from "./pages/SubjectsList";
import CategoryManager from "./pages/CategoryManager";
import AppUpdateManager from "./pages/AppUpdateManager";
import ChaptersList from "./pages/ChaptersList";
import AddChapter from "./pages/AddChapter";
import PrepareNewTestSeries from "./pages/PrepareNewTestSeries";
import MockTestSeries from "./pages/MockTestSeries";
import UpdateMockTestSeries from "./pages/UpdateMockTestSeries";
import AddNotes from "./pages/AddNotes";
import NotesList from "./pages/NotesList";
import NotesDetails from "./pages/NotesDetails";
import TypeManager from "./pages/TypeManager";
import AddTopics from "./pages/AddTopics";
import TopicsList from "./pages/TopicsList";
import EditNote from "./pages/EditNote";
import StudentRegistrationPage from "./pages/StudentRegistrationPage";
import StudentsList from "./pages/StudentsList";
import AttendancePage from "./pages/AttendancePage";
import CoursesPage from "./pages/CoursesPage";
import BatchesPage from "./pages/BatchesPage";
import CreateBatchPage from "./pages/CreateBatchPage";
import TeachersPage from "./pages/TeachersPage";
import RegisterTeacherPage from "./pages/RegisterTeacherPage";
import EditTeacher from "./pages/EditTeacher";
import EditStudent from "./pages/EditStudent";
import ClassSchedulePage from "./pages/ClassSchedulePage";
import FeeStructurePage from "./pages/FeeStructurePage";
import PaymentsPage from "./pages/PaymentsPage";
import InvoicesPage from "./pages/InvoicesPage";
import FeeReportsPage from "./pages/FeeReportsPage";
import AnnouncementsPage from "./pages/AnnouncementsPage";
import NotificationsPage from "./pages/NotificationsPage";
import PerformanceReportsPage from "./pages/PerformanceReportsPage";
import AttendanceReportsPage from "./pages/AttendanceReportsPage";
import CustomReportsPage from "./pages/CustomReportsPage";
import GeneralSettings from "./pages/GeneralSettings";
import UserRoles from "./pages/UserRoles";
import AccountSettings from "./pages/AccountSettings";
import AttendanceListPage from "./pages/AttendanceListPage";
import QuizSubjects from "./pages/QuizSubjects";
import QuizTopics from "./pages/QuizTopics";
import QuizQuestions from "./pages/QuizQuestions";
import QuizNotifications from "./pages/QuizNotifications";

export default function App() {
  const Scroll = (props) => {
    const location = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [location]);
    return props.children;
  };

  return (
    <div>
      <ToastContainer position="top-right" />
      <Authentication>
        <Scroll>
          <div className="text-sm text-slate-600">
            <Routes>
              <Route path="login" element={<LoginPage />} />
              <Route path="register" element={<Register />} />
              <Route path="*" element={<NotFound />} />
              <Route path="/" element={<Navigate to="/my" />} />
              <Route path="/my" element={<AppAuth />}>
                <Route path="" element={<Homepage />} />
                <Route path="profile" element={<ProfilePage />} />
                <Route
                  path="addDailyUpdate"
                  element={
                    <RequireAuth
                      component={<AddDailyUpdate />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="dailyUpdatesList"
                  element={
                    <RequireAuth
                      component={<DailyUpdatesList />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="addQuestionsInBulk"
                  element={
                    <RequireAuth
                      component={<AddQuestionsInBulk />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="addNewQuestion"
                  element={
                    <RequireAuth
                      component={<AddNewQuestion />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="prepareNewTestSeries"
                  element={
                    <RequireAuth
                      component={<PrepareNewTestSeries />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="mockTestSeries"
                  element={
                    <RequireAuth
                      component={<MockTestSeries />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="questionsList"
                  element={
                    <RequireAuth
                      component={<QuestionsList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="updateMockTestSeries"
                  element={
                    <RequireAuth
                      component={<UpdateMockTestSeries />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="addSubject"
                  element={
                    <RequireAuth
                      component={<AddSubject />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="subjectsList"
                  element={
                    <RequireAuth
                      component={<SubjectsList />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="addChapter"
                  element={
                    <RequireAuth
                      component={<AddChapter />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="chaptersList"
                  element={
                    <RequireAuth
                      component={<ChaptersList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="addNotes"
                  element={
                    <RequireAuth
                      component={<AddNotes />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="notesList"
                  element={
                    <RequireAuth
                      component={<NotesList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="notesDetails"
                  element={
                    <RequireAuth
                      component={<NotesDetails />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="editNote"
                  element={
                    <RequireAuth
                      component={<EditNote />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="chaptersList"
                  element={
                    <RequireAuth
                      component={<ChaptersList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="addTopics"
                  element={
                    <RequireAuth
                      component={<AddTopics />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="topicsList"
                  element={
                    <RequireAuth
                      component={<TopicsList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Quiz App Routes */}
                <Route
                  path="quiz-subjects"
                  element={
                    <RequireAuth
                      component={<QuizSubjects />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="quiz-topics"
                  element={
                    <RequireAuth
                      component={<QuizTopics />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="quiz-questions"
                  element={
                    <RequireAuth
                      component={<QuizQuestions />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="quiz-notifications"
                  element={
                    <RequireAuth
                      component={<QuizNotifications />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Settings */}
                <Route
                  path="typeManager"
                  element={
                    <RequireAuth
                      component={<TypeManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="categoryManager"
                  element={
                    <RequireAuth
                      component={<CategoryManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="appUpdateManager"
                  element={
                    <RequireAuth
                      component={<AppUpdateManager />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="studentRegistration"
                  element={
                    <RequireAuth
                      component={<StudentRegistrationPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="studentsList"
                  element={
                    <RequireAuth
                      component={<StudentsList />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="editStudent/:id"
                  element={
                    <RequireAuth
                      component={<EditStudent />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="attendanceList"
                  element={
                    <RequireAuth
                      component={<AttendanceListPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="attendance"
                  element={
                    <RequireAuth
                      component={<AttendancePage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="courses"
                  element={
                    <RequireAuth
                      component={<CoursesPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="batches"
                  element={
                    <RequireAuth
                      component={<BatchesPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="createBatch"
                  element={
                    <RequireAuth
                      component={<CreateBatchPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="schedule"
                  element={
                    <RequireAuth
                      component={<ClassSchedulePage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="editBatch/:id"
                  element={
                    <RequireAuth
                      component={<CreateBatchPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="teachers"
                  element={
                    <RequireAuth
                      component={<TeachersPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                <Route
                  path="registerTeacher"
                  element={
                    <RequireAuth
                      component={<RegisterTeacherPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="editTeacher/:id"
                  element={
                    <RequireAuth
                      component={<EditTeacher />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="schedule"
                  element={
                    <RequireAuth
                      component={<ClassSchedulePage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Fee Management */}
                <Route
                  path="feeStructure"
                  element={
                    <RequireAuth
                      component={<FeeStructurePage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="payments"
                  element={
                    <RequireAuth
                      component={<PaymentsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="invoices"
                  element={
                    <RequireAuth
                      component={<InvoicesPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="feeReports"
                  element={
                    <RequireAuth
                      component={<FeeReportsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                {/* Communication */}
                <Route
                  path="announcements"
                  element={
                    <RequireAuth
                      component={<AnnouncementsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="notifications"
                  element={
                    <RequireAuth
                      component={<NotificationsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Reports */}
                <Route
                  path="performanceReports"
                  element={
                    <RequireAuth
                      component={<PerformanceReportsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="attendanceReports"
                  element={
                    <RequireAuth
                      component={<AttendanceReportsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="customReports"
                  element={
                    <RequireAuth
                      component={<CustomReportsPage />}
                      userTypes={["admin"]}
                    />
                  }
                />

                {/* Settings Pages */}
                <Route
                  path="generalSettings"
                  element={
                    <RequireAuth
                      component={<GeneralSettings />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="userRoles"
                  element={
                    <RequireAuth
                      component={<UserRoles />}
                      userTypes={["admin"]}
                    />
                  }
                />
                <Route
                  path="accountSettings"
                  element={
                    <RequireAuth
                      component={<AccountSettings />}
                      userTypes={["admin"]}
                    />
                  }
                />
              </Route>
            </Routes>
          </div>
        </Scroll>
      </Authentication>
    </div>
  );
}
